import Widget from '@/plugins/dashboard/widgets/Cube/Widget'
import Configure from '@/plugins/dashboard/widgets/Cube/Configure'
import Chart from '@/plugins/dashboard/classes/Chart'

export default class extends Chart {
  static name = 'Cube'
  static widget = Widget
  static configure = Configure
}
